export const environment = {
  production: false,
  baseUrl: "https://test.micsto.com",
  baseUrlApi: "https://api.test.micsto.com",
  manualUrl: "https://static.micsto.com"
}